import { apiRequest } from './apiWrapper'

export async function fetchSettingsApi() {
  const userId = JSON.parse(localStorage.getItem('user'))?.user_id
  const isSocialUser = JSON.parse(localStorage.getItem('isSocialUser'))
  const response = await apiRequest({
    method: 'get',
    url:`/settings?is_social=${isSocialUser}`,
    headers: { 'x-user-id': userId }
  })
  return response
}

export async function fetchNotificationSettingsApi() {
  const response = await apiRequest({
    method: 'get',
    url: 'notification-settings/'
  })
  return response
}

export async function updateNotificationSettingsApi(data) {
  const response = await apiRequest({
    method: 'put',
    url: '/notification-settings/',
    data
  })
  return response
}

export async function fetchFeedbackSupportOptionsApi() {
  const response = await apiRequest({
    method: 'get',
    url: '/feedback-supprots-options/'
  })
  return response
}

export async function fetchSubmitFeedbackApi(data) {
  const response = await apiRequest({
    method: 'post',
    url: '/feedback/',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response
}

export async function fetchCookieConsentApi() {
  const deviceId = localStorage.getItem('deviceId')
  const response = await apiRequest({
    method: 'get',
    url: '/v1/cookie-consent/',
    headers: { 'x-device-id': deviceId },
    skipCache: true
  })
  return response
}

export async function updateCookieConsentApi(data) {
  const deviceId = localStorage.getItem('deviceId')
  const response = await apiRequest({
    method: 'put',
    url: '/v1/cookie-consent/',
    data,
    headers: { 'x-device-id': deviceId }
  })
  return response
}
